const RECOVERY_FLAG_KEY = "jobteen_pw_recovery_in_progress";
const RESET_RATE_LIMIT_KEY = "jobteen_pw_reset_last_request";

// If the app gets into a weird state, don't block forever.
// We keep it long enough to cover a full reset flow, but it will self-clear.
const RECOVERY_FLAG_TTL_MS = 2 * 60 * 60 * 1000; // 2h

export const markPasswordRecoveryInProgress = () => {
  try {
    localStorage.setItem(RECOVERY_FLAG_KEY, String(Date.now()));
  } catch {
    // ignore
  }
};

export const clearPasswordRecoveryInProgress = () => {
  try {
    localStorage.removeItem(RECOVERY_FLAG_KEY);
  } catch {
    // ignore
  }
};

export const isPasswordRecoveryInProgress = (): boolean => {
  try {
    const raw = localStorage.getItem(RECOVERY_FLAG_KEY);
    if (!raw) return false;
    const ts = Number(raw);
    if (!Number.isFinite(ts)) return true;
    if (Date.now() - ts > RECOVERY_FLAG_TTL_MS) {
      localStorage.removeItem(RECOVERY_FLAG_KEY);
      return false;
    }
    return true;
  } catch {
    return false;
  }
};

export const isRecoveryHash = (hash: string): boolean => {
  if (!hash) return false;
  const cleaned = hash.startsWith("#") || hash.startsWith("?") ? hash.slice(1) : hash;
  const params = new URLSearchParams(cleaned);
  return (
    params.get("type") === "recovery" ||
    params.has("access_token") ||
    params.has("refresh_token")
  );
};

export const getPasswordResetRedirectTo = (): string => {
  // In production, we want the canonical domain (and to avoid random staging origins).
  // In dev/preview, use the current origin so it works without extra allowlists.
  const origin = import.meta.env.PROD ? "https://jobteen.app" : window.location.origin;
  return `${origin}/reset-password`;
};

export const getResetRateLimitSecondsRemaining = (): number => {
  try {
    const raw = localStorage.getItem(RESET_RATE_LIMIT_KEY);
    if (!raw) return 0;
    const ts = Number(raw);
    if (!Number.isFinite(ts)) return 0;
    const diffMs = Date.now() - ts;
    const remaining = 60_000 - diffMs;
    return remaining > 0 ? Math.ceil(remaining / 1000) : 0;
  } catch {
    return 0;
  }
};

export const stampResetRateLimit = () => {
  try {
    localStorage.setItem(RESET_RATE_LIMIT_KEY, String(Date.now()));
  } catch {
    // ignore
  }
};
